var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarFull = function SvgStarFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.157 11.064a1.33 1.33 0 0 0-1.076-.907l-8.213-1.193-3.673-7.443c-.448-.91-1.943-.91-2.391 0L10.13 8.962l-8.214 1.193a1.333 1.333 0 0 0-.737 2.274l5.943 5.792-1.405 8.18a1.334 1.334 0 0 0 1.935 1.406l7.345-3.863 7.346 3.863a1.335 1.335 0 0 0 1.404-.101 1.33 1.33 0 0 0 .53-1.305l-1.404-8.18 5.943-5.792c.364-.354.494-.885.338-1.367z"
  })));
};
export default SvgStarFull;